module.exports = __webpack_public_path__ + "static/media/cover_abi_deutsch.24031e4d.jpg";